module.exports = __webpack_public_path__ + "img/Time.bec47b8a.svg";